export default __webpack_public_path__ + "static/illustration-29a63c5d8e6ccfa4a2b67e28b461a48f.svg";